/* eslint-disable */
import { React, Component, Fragment } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";

import avatar from "assets/img/faces/marc.jpg";
import Spinner from 'components/Spinner.js';
import moment from "moment";

import SiteList from "./SiteList";

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
};

const useStyles = makeStyles(styles);

export default function (props) {
  const classes = useStyles();
  return <PrinterProfile classes={classes} {...props} />
}

class PrinterProfile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newPrinterMode: props.printerId == null,
      showSpinner: true,
      showData: false,
      updating: false,
      printerId: props.printerId,
      fields: props.fields || [
            `name`,
            `description`,
            `path`,
            `enabled`,
            ].reduce((p,c) => {
                p[c] = props[c] || '';
                return p;
            }, {}),
      data: {},
      message: '',
    };
  }

  componentDidMount() {
    if (this.state.newPrinterMode)
    {
      this.setState({
        showSpinner: false,
        showData: true
      });
    }
    else
      this.refreshUser();
  }

  refreshUser = () => {
    var $this = this;
    fetch(`/api/shared/printers/lookup/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify({ printerId: $this.state.printerId })
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        if (data.status.success) {
          var printer = data.data.printer;
          var fields = {};
          fields.name = printer.name;
          fields.description = printer.description;
          fields.path = printer.path;
          fields.enabled = printer.enabled;

          $this.setState({
            data: printer,
            fields: fields,
            showSpinner: false,
            showData: true
          });
        }
        else {
          $this.setState({
            showSpinner: false
          });
          alert('There was an error. Please try again later.')
        }
      }).catch(() => {
        $this.setState({
          showSpinner: false
        });
        alert('There was an error. Please try again later.')
      });
  }

  handleOnChange = (e) => {
    const fields = this.state.fields;
    fields[e.target.name] = e.target.value;
    //const fieldErrors = this.validate(fields)
    this.setState({ fields, 
      //fieldErrors, formValidated: true, showError: null 
    });
  }

  handleUpdate = () => {
    const fields = this.state.fields;
    this.setState({
      updating: true,
    })
    //userId, string email, string last_name, string other_names
    var $this = this;
    fetch(`/api/shared/printers/${$this.state.newPrinterMode ? 'new' : 'update'}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify({ 
        printerId: $this.state.printerId, 
        name: fields.name,
        description: fields.description, 
        path: fields.path, 
        enabled: fields.enabled, 
       })
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        if (data.status.success) {
          var printer = data.data.printer;
          var fields = {};
          fields.name = printer.name;
          fields.description = printer.description;
          fields.path = printer.path;
          fields.enabled = printer.enabled;

          $this.setState({
            data: printer,
            fields: fields,
            showSpinner: false,
            showData: true,
            updating: false,
            message: `Printer ${$this.state.newPrinterMode ? 'added' : 'updated'}.`,
            printerId: printer.id,
            newPrinterMode: false,
          });
        }
        else {
          $this.setState({
            showSpinner: false,
            updating: false,
            message: `Error ${$this.state.newPrinterMode ? 'adding' : 'updating'} Printer. Please try again later.`
          });
          //alert('There was an error. Please try again later.')
        }
      }).catch(() => {
        $this.setState({
          showSpinner: false,
          updating: false,
          message: `Error ${$this.state.newPrinterMode ? 'adding' : 'updating'} Printer. Please try again later.`
        });
      });
  }

  render () 
  {
    const classes = this.props.classes;
    return (
      <div>
        { this.state.showSpinner ?
          <Spinner/> 
          : "" 
        }
        { this.state.showData ?
        <GridContainer>
          <GridItem xs={12} sm={12} md={8}>
            <Card>
              <CardHeader color="primary">
                <h4 className={classes.cardTitleWhite}>{this.state.newPrinterMode ? 'Add' : 'Update'} Printer {this.state.data.username}</h4>
                <p className={classes.cardCategoryWhite}>Complete printer details</p>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText="Name"
                      id="name"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        name: "name",
                        value: this.state.fields.name || '',
                        onChange: this.handleOnChange,
                        //readOnly: !this.state.newUserMode,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText="Description"
                      id="description"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        name: "description",
                        value: this.state.fields.description || '',
                        onChange: this.handleOnChange,
                        readOnly: false,
                      }}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={9}>
                    <CustomInput
                      labelText="Path"
                      id="path"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        name: "path",
                        value: this.state.fields.path || '',
                        onChange: this.handleOnChange,
                        //readOnly: !this.state.newUserMode,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={3}>
                    {/* <CustomInput
                      labelText="Enabled"
                      id="enabled"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        name: "enabled",
                        //value: this.state.fields.enabled || '',
                        onChange: this.handleOnChange,
                        type: 'checkbox',
                        defaultChecked: this.state.fields.enabled
                      }}
                    /> */}
                    <Button color={this.state.fields.enabled ? 'danger' : 'primary'} onClick={() => this.handleOnChange({
                      target: {
                        name: 'enabled',
                        value: !this.state.fields.enabled
                      }
                    })}>
                      {this.state.fields.enabled ? 'Disable' : 'Enable'} Printer
                      </Button>
                  </GridItem>
                </GridContainer>
                {this.state.printerId ?
                  <SiteList printerId={this.state.printerId} />
                : null}
              </CardBody>
              <CardFooter>
                {this.state.updating ?
                <Fragment>
                  <Button color="primary" disabled>{this.state.newPrinterMode ? 'Add' : 'Update'} Printer</Button>
                  <Spinner/>
                </Fragment>
                :
                <Fragment>
                  <Button color="primary" onClick={this.handleUpdate}>{this.state.newPrinterMode ? 'Add' : 'Update'} Printer</Button>
                  <span>{this.state.message}</span>
                </Fragment>
                }
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            {/* <Card profile>
              <CardAvatar profile>
                <a href="#pablo" onClick={(e) => e.preventDefault()}>
                  <img src={avatar} alt="..." />
                </a>
              </CardAvatar>
              <CardBody profile>
                <h6 className={classes.cardCategory}>CEO / CO-FOUNDER</h6>
                <h4 className={classes.cardTitle}>Alec Thompson</h4>
                <p className={classes.description}>
                  Don{"'"}t be scared of the truth because we need to restart the
                  human foundation in truth And I love you like Kanye loves Kanye
                  I love Rick Owens’ bed design but the back is...
                </p>
                <Button color="primary" round>
                  Follow
                </Button>
              </CardBody>
            </Card> */}
          </GridItem>
        </GridContainer>
        : null }
      </div>
    );
  }
}
